import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { HubHookFormCustomerAddress } from "../HubHookFormCustomerAddress";
import { HubHookCustomersSelect } from "../HubHookCustomersSelect";

import { StyledCardStack, StyledShipmentBox } from "./styles";

export const Label = ({ label, value, isRow }) => {
  const sx = isRow
    ? {
        direction: "row",
        gap: "3px",
        alignItems: "center",
      }
    : {};

  return (
    <Stack {...sx}>
      <Typography variant="subtitle2">{label}</Typography>
      <Typography variant="caption" fontWeight={500}>
        {value}
      </Typography>
    </Stack>
  );
};

const ShipmentInfo = () => {
  const { watch } = useFormContext();
  const customerId = watch("customerId");
  const returnCustomerId = watch("returnCustomerId");

  return (
    <Stack direction="row" justifyContent="space-between">
      <StyledCardStack>
        <Stack gap="2px">
          <Typography variant="caption" lineHeight="12px">
            To:
          </Typography>
          <StyledShipmentBox>
            <HubHookCustomersSelect
              name="customerId"
              label={null}
              shouldUnregister={false}
              rendered={false}
              required
            />
            <HubHookFormCustomerAddress
              name="shipTo"
              label={null}
              customerId={customerId}
              sx={{ minHeight: "46px" }}
              shouldUnregister={false}
              rendered
            />
          </StyledShipmentBox>
        </Stack>
      </StyledCardStack>
      <StyledCardStack>
        <Stack gap="2px">
          <Typography variant="caption" lineHeight="12px">
            Ship To:
          </Typography>
          <StyledShipmentBox>
            <HubHookCustomersSelect
              name="returnCustomerId"
              label={null}
              shouldUnregister={false}
              rendered={false}
              required
            />
            <HubHookFormCustomerAddress
              name="returnTo"
              label={null}
              customerId={returnCustomerId}
              shouldUnregister={false}
              sx={{ minHeight: "46px" }}
              rendered
            />
          </StyledShipmentBox>
        </Stack>
      </StyledCardStack>
    </Stack>
  );
};

export default ShipmentInfo;
